var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4782,22.2815H6.1823A6.1533,6.1533,0,0,1,0,16.1444V6.8033A6.1533,6.1533,0,0,1,6.1823.6662h9.341a6.1435,6.1435,0,0,1,6.1372,6.1371v9.3411A6.1533,6.1533,0,0,1,15.4782,22.2815ZM6.1823,2.5163a4.285,4.285,0,0,0-4.287,4.287v9.3411a4.285,4.285,0,0,0,4.287,4.2869h9.341a4.285,4.285,0,0,0,4.287-4.2869V6.8033a4.285,4.285,0,0,0-4.287-4.287Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.83,17.0018a5.5505,5.5505,0,1,1,5.5505-5.55A5.5466,5.5466,0,0,1,10.83,17.0018Zm0-9.2057a3.7,3.7,0,1,0,3.7,3.7A3.717,3.717,0,0,0,10.83,7.7961Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.96,5.5849a1.3538,1.3538,0,1,1-1.3537-1.3538A1.42,1.42,0,0,1,17.96,5.5849Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.ea6c3d547ff276c45db7bcac4bf19b90.svg";
export { ForwardRef as ReactComponent };